import TeammatesList from './TeammatesList';

export default TeammatesList;
